import React, { useState } from 'react';
import style from './index.module.css';
import { Image, Button, Tag, Tooltip, Modal, Rate } from 'antd';
import { Lightbox } from 'react-modal-image';

import {
    FullscreenOutlined,
    ExclamationCircleOutlined,
    WarningOutlined,
    CheckCircleTwoTone,
    CheckCircleOutlined,
    FrownOutlined,
    MehOutlined,
    SmileOutlined,
} from '@ant-design/icons';

export default function ImageFx({
    image,
    allowFullSize = false,
    viewFullSizeFirst = false,
    showVerifiedIcon = false,
    shootStatus = '',
    caption,
    header,
    usageCount,
    srNo,
    width = '200px',
    height = '300px',
    rating = 2,
    displayRating = false,
    updateRatingFn = null,
    isStudioCCFile = false,
}) {
    const customIcons = {
        1: <FrownOutlined />,
        2: <FrownOutlined />,
        3: <MehOutlined />,
        4: <SmileOutlined />,
        5: <SmileOutlined />,
    };
    const style2 = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        minWidth: '100%',
        height: '100%',
        outline: '10px solid #000',
    };

    const [open, setOpen] = useState(false);
    const [isHovering, setIsHovering] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const UpdateRating = value => {
        updateRatingFn(value);
    };

    const GetShootStatusIcon = ({ shootStatus, showVerifiedIcon, srNo }) => {
        if (!shootStatus) {
            if (!!showVerifiedIcon) {
                if (!!srNo) {
                    return (
                        <Tooltip title={'Completed'}>
                            <Tag style={{ backgroundColor: 'gray' }} icon={<CheckCircleTwoTone className={style.verifiedIcon} />}>
                                {srNo}
                            </Tag>
                        </Tooltip>
                    );
                } else {
                    return (
                        <Tooltip title={'Completed'}>
                            <CheckCircleTwoTone className={style.verifiedIcon} />
                        </Tooltip>
                    );
                }
            }
        } else {
            if (shootStatus == 'Pending') {
                if (!!srNo) {
                    return (
                        <Tooltip title="Pending">
                            <Tag className={style.pending} icon={<WarningOutlined />}>
                                {srNo}
                            </Tag>
                        </Tooltip>
                    );
                } else {
                    return (
                        <Tooltip title="Pending">
                            <WarningOutlined className={style.pending} />
                        </Tooltip>
                    );
                }
            } else if (shootStatus == 'Partial') {
                if (!!srNo) {
                    return (
                        <Tooltip style={{ backgroundColor: 'gray' }} title="Partial">
                            <Tag className={style.partial} icon={<ExclamationCircleOutlined />}>
                                {srNo}
                            </Tag>
                        </Tooltip>
                    );
                } else {
                    return (
                        <Tooltip title="Partial">
                            <ExclamationCircleOutlined className={style.partial} />
                        </Tooltip>
                    );
                }
            } else if (shootStatus == 'Complete') {
                if (!!srNo) {
                    return (
                        <Tooltip title="Completed">
                            <Tag className={style.verifiedIcon} icon={<CheckCircleTwoTone />}>
                                {srNo}
                            </Tag>
                        </Tooltip>
                    );
                } else {
                    return (
                        <Tooltip title="Completed">
                            <CheckCircleTwoTone className={style.verifiedIcon} />
                        </Tooltip>
                    );
                }
            }
        }
    };

    const StatusIcon = ({ shootStatus, showVerifiedIcon = false }) => {
        let status = shootStatus;
        if (!!showVerifiedIcon) {
            status = 'Complete';
        }
        if (!status) {
            return;
        }
        return (
            <>
                {status == 'Complete' && (
                    <Tooltip title="Complete">
                        <CheckCircleOutlined className={style.verifiedIcon} />
                    </Tooltip>
                )}
                {status == 'Pending' && (
                    <Tooltip title="Pending">
                        <ExclamationCircleOutlined className={style.pending} />
                    </Tooltip>
                )}
                {status == 'Partial' && (
                    <Tooltip title="Partial">
                        <WarningOutlined className={style.partial} />
                    </Tooltip>
                )}
            </>
        );
    };

    return (
        <>
            <div
                style={{
                    position: 'relative',
                    margin: '0',
                    padding: '0',
                    width: width || '200px',
                    height: height || '300px',
                    // border: '1px solid black',
                    borderRadius: '10px',
                    boxShadow: !isHovering ? '' : '1px 1px 5px #000',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
                onMouseEnter={() => setIsHovering(true)}
                onMouseLeave={() => setIsHovering(false)}
                onBlur={() => setIsHovering(false)}
            >
                {!!image ? (
                    <Image
                        style={{
                            borderRadius: '10px',
                        }}
                        src={!viewFullSizeFirst ? image?.thumbPath?.url : image?.imagePath?.url}
                        preview={false}
                        fallback="data:image/png;base64,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"
                    />
                ) : (
                    <Image
                        style={{
                            borderRadius: '10px',
                        }}
                        preview={false}
                        src="data:image/png;base64,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"
                    />
                )}
                {!!header && <p className={style.header}>{header}</p>}
                {/* {!!isStudioCCFile && <p className={style.caption2}>{!!isStudioCCFile ? 'Studio CC File' : null}</p>} */}
                {!!caption && <p className={style.caption}>{caption}</p>}
                {!!displayRating && (
                    <Rate
                        style={{
                            position: 'absolute',
                            bottom: '18px',
                            display: 'flex',
                            left: '2px',
                            fontSize: '0.75rem',
                            color: rating < 3 ? 'red' : 'green',
                        }}
                        onChange={UpdateRating}
                        defaultValue={rating}
                        character={({ index }) => customIcons[index + 1]}
                    />
                )}
                <div
                    style={{
                        position: 'absolute',
                        top: '10%',
                        left: '1px',
                        display: 'flex',
                        flexDirection: 'column',
                        backgroundColor: '#00000055', //'#77777777',
                        borderRadius: '13px 13px 13px 13px',
                        width: '26px',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <div
                        style={{
                            display: 'flex',
                            // height: '26px',
                            width: '26px',
                            justifyContent: 'center',
                            alignItems: 'center',
                            borderRadius: '13px 13px 0 0',
                            border: !!shootStatus ? '1px solid white' : '',
                            minHeight: !!shootStatus ? '26px' : '0',
                        }}
                    >
                        <StatusIcon shootStatus={shootStatus} showVerifiedIcon={showVerifiedIcon} />
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            width: '26px',
                            justifyContent: 'center',
                            alignItems: 'center',
                            border: !!srNo ? '1px solid white' : '',
                        }}
                    >
                        {!!srNo && (
                            <Tooltip title={'Sku serial number'}>
                                <p
                                    style={{
                                        color: 'white',
                                        transform: 'rotate(-90deg)',
                                    }}
                                >
                                    {srNo}
                                </p>
                            </Tooltip>
                        )}
                    </div>

                    <div
                        style={{
                            display: 'flex',
                            // height: '26px',
                            width: '26px',
                            justifyContent: 'center',
                            alignItems: 'center',
                            borderRadius: ' 0 0 13px 13px',
                            border: !!usageCount ? '1px solid white' : '',
                        }}
                    >
                        <Tooltip title="Studio CC File">
                            {isStudioCCFile && (
                                <div
                                    style={{
                                        width: '20px',
                                        height: '20px',
                                        position: 'absolute',
                                        top: '25px',
                                        // left: '5px',
                                        backgroundColor: 'rgba(255, 192, 203, 0.5)',
                                    }}
                                >
                                    <img
                                        src="studiolight.png"
                                        alt="StudioIcon"
                                        style={{
                                            width: '100%',
                                            height: '100%',
                                            borderRadius: '8px',
                                        }}
                                    />
                                </div>
                            )}
                        </Tooltip>
                        <Tooltip title="No of times selected for production">
                            <p
                                style={{
                                    color: 'white',
                                    textAlign: 'center',
                                    width: '100%',
                                    height: '100%',
                                    borderRadius: '0 0 13px 13px',
                                    alignItems: 'center',
                                }}
                            >{`${usageCount || ''}`}</p>
                        </Tooltip>
                    </div>
                </div>

                {allowFullSize && (
                    <Button type="secondary" onClick={handleOpen} className={style.fullscreenBtn}>
                        <FullscreenOutlined />
                    </Button>
                )}

                {open && (
                    <Modal open={open} onClose={handleClose}>
                        <div style={style}>
                            <Lightbox
                                small={image?.thumbPath?.url}
                                large={image?.imagePath?.url}
                                onClose={handleClose}
                                key={image?.imagePath?.key}
                                hideZoom={false}
                                showRotate={true}
                                hideDownload={false}
                                alt={caption}
                            />
                        </div>
                    </Modal>
                )}
            </div>
        </>
    );
}
